



















import { defineComponent, onBeforeMount, onMounted, reactive, toRefs, watch } from '@vue/composition-api'
import Alerts, { AlertType } from '@/code/alerts';
import { tablas, SetDates } from '@/code/Utils';

import ingresar from '@/components/Ingresar.vue'
import visualizar from '@/components/Visualizar.vue'
import historico from '@/components/Historico.vue'

export const FormatDate = (date: string) => {
    let datePart = date.match(/\d+/g), day, month, year;
    if (datePart) {
        day = datePart[2],
        month = datePart[1],
        year = datePart[0];

        return day + "/" + month + "/" + year;
    }
}

export const Search = (tabla:string, ev: KeyboardEvent) => {
    const alert = document.querySelectorAll(".pol-alert");
    const search = Home.search.toLowerCase().trim();
    const items = Home.tablas[tabla] as tablas[];
    const keys = ["Fecha", "Nro_contrato", "Local", "Rubro", "Moneda_des", "Tipo_cambio", "Cantidad", "Importe"]
        if(search.length > 1 || ( Home.tab == 'ingresar' && Home.date)){
            for(var i=0; i < items.length; i++){
                let bool;
                const item = items[i];
                let Fecha_reg = FormatDate(item.Fecha) 
                for(var index = 0; index < keys.length -1; index++){
                    const value = item[keys[index]].toLowerCase();
                    bool = index == 0 ? Fecha_reg.indexOf(search) != -1 : bool || value.indexOf(search) != -1;
                }
                item.show = bool;
            }
        } else if(Home.date == '' && alert.length == 0 && Home.tab == 'ingresar' && (ev.keyCode != 8 && ev.keyCode != 32)) {
            Alerts.Throw(`Debe seleccionar una fecha para realizar la busqueda.`, AlertType.Danger, false, 5000)
        } else if(search.length < 2){
        for(var i=0; i < items.length; i++){
            items[i].show = true;
        }
    } 
}

export const Home = reactive({
    date: '',
    desde: '',
    hasta: '',
    min: '',
    max: '',
    search: '',
    tab: '',
    tablas: {
        ingresar: [] as tablas[],
        visualizar: [] as tablas[],
        historico: [] as tablas[]
    },
    pagination: {
        rowPerPage: 25,
        page: 0,
        count: 1,
        pages: 1
    }
})

export default defineComponent({
    name: 'Home',
    components: {
        ingresar,
        visualizar,
        historico
    },
    setup(props, context) {
        watch(() => Home.tab, (value, oldvalue) => {
            const today = new Date();
            if(value != oldvalue) {
                Home.search = '';
                if(value == 'ingresar') {
                    today.setDate(today.getDate() - 1);
                    Home.date = today.toISOString().split("T")[0];
                    Home.max = today.toISOString().split("T")[0];
                    today.setDate(today.getDate() - 59);
                    Home.min = today.toISOString().split("T")[0];
                } else {
                    const data = SetDates();
                    Home.desde = data.desde;
                    Home.hasta = data.hasta;
                    Home.max = today.toISOString().split("T")[0];
                    today.setMonth(today.getMonth() - 6);
                    Home.min = today.toISOString().split("T")[0];
                }
            }
        })

        onBeforeMount(async() => {
            const data = context.root.$store.state.session;
            if(!data.user && !data.companyCode){
                const SessionStorage = sessionStorage.getItem("UserLogin")
                if(!SessionStorage) {
                    context.root.$router.push('./').then(() => {
                        Alerts.Throw("La sesión ha expirado, por favor ingrese nuevamente.", AlertType.Danger, false, 6000)
                    })
                } else {
                    context.root.$store.commit('setSession', JSON.parse(SessionStorage))
                }
            }
        })

        onMounted(() => {
            Home.tab = 'ingresar'
        })
        
        console.log(context.root.$store.state.session.companyName);
        return {
            ...toRefs(Home),
        }
    }
});
